export type BundleItemData = {
	bundleItem: boolean;
};

export const isBundleItemData = (
	fieldData: unknown,
): fieldData is BundleItemData => {
	const data = fieldData as Partial<BundleItemData>;
	return typeof data.bundleItem === "boolean";
};
